import { Api } from '@/Api';

export const useAdminActions = () => {
  const stopImpersonating = async () => {
    try {
      await Api.admin.stopImpersonating();
      // Redirect to admin page after successful stop impersonating
      window.location.href = '/admin';
    } catch (error) {
      console.error('Failed to stop impersonating:', error);
      throw error;
    }
  };

  return {
    stopImpersonating,
  };
};
